export default __webpack_public_path__ + "static/media/register.101cb538.svg";